/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type GetMyHardwareRequestItemsQueryVariables = Types.Exact<{
  hardware_request_id: Types.Scalars["Float"];
}>;

export type GetMyHardwareRequestItemsQuery = {
  myHardwareRequestItems: Array<
    Pick<Types.HardwareItemRequest, "id" | "quantity" | "hardware_item_id"> & {
      HardwareItem: Pick<
        Types.HardwareItem,
        "id" | "sku_code" | "available_quantity"
      >;
    }
  >;
};

export const GetMyHardwareRequestItemsDocument = gql`
  query GetMyHardwareRequestItems($hardware_request_id: Float!) {
    myHardwareRequestItems(hardware_request_id: $hardware_request_id) {
      id
      quantity
      hardware_item_id
      HardwareItem {
        id
        sku_code
        available_quantity
      }
    }
  }
`;

/**
 * __useGetMyHardwareRequestItemsQuery__
 *
 * To run a query within a React component, call `useGetMyHardwareRequestItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyHardwareRequestItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyHardwareRequestItemsQuery({
 *   variables: {
 *      hardware_request_id: // value for 'hardware_request_id'
 *   },
 * });
 */
export function useGetMyHardwareRequestItemsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetMyHardwareRequestItemsQuery,
    GetMyHardwareRequestItemsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetMyHardwareRequestItemsQuery,
    GetMyHardwareRequestItemsQueryVariables
  >(GetMyHardwareRequestItemsDocument, baseOptions);
}
export function useGetMyHardwareRequestItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMyHardwareRequestItemsQuery,
    GetMyHardwareRequestItemsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetMyHardwareRequestItemsQuery,
    GetMyHardwareRequestItemsQueryVariables
  >(GetMyHardwareRequestItemsDocument, baseOptions);
}
export type GetMyHardwareRequestItemsQueryHookResult = ReturnType<
  typeof useGetMyHardwareRequestItemsQuery
>;
export type GetMyHardwareRequestItemsLazyQueryHookResult = ReturnType<
  typeof useGetMyHardwareRequestItemsLazyQuery
>;
export type GetMyHardwareRequestItemsQueryResult =
  ApolloReactCommon.QueryResult<
    GetMyHardwareRequestItemsQuery,
    GetMyHardwareRequestItemsQueryVariables
  >;
